var ReactRedux = require('react-redux');
var Reselect = require('reselect');

var orderActions = require('../../../actions/orderActions');
var OrdersPresentational = require('../../../components/Admin/Orders/Orders.jsx');

var { createSelector } = Reselect;

export function getOrders(state) {
	return state.orders;
};

export function getOrderList(state) {
	return getOrders(state).list;
};

export function getOrderFilter(state) {
	return getOrders(state).filter;
};

export const getVisibleOrders = createSelector(
	getOrderList,
	getOrderFilter,
	(orders, filter) => {
		switch (filter) {
			/*case 'open':
				return orders.filter(order => order.status === 0);*/

			case 'closed':
				return orders.filter(order => order.status > 0);

			case 'companies':
				return orders.filter(order => order.paymentMethod === 2);

			default:
				return orders.filter(order => order.status === 0);
		}
	}
);

var mapStateToProps = function(state) {
	return createSelector (
		getVisibleOrders,
		(orders) => ({
			orders
		})
	);
};

var mapDispatchToProps = function(dispatch) {
	return {
		load: function() {
			dispatch(orderActions.loadOrders());
		},

		unload: function() {
			dispatch(orderActions.unsubscribe());
		},

		filter: function(type) {
			dispatch(orderActions.filterOrders(type));
		}
	};
};

module.exports = ReactRedux.connect(
	mapStateToProps, mapDispatchToProps
)(OrdersPresentational);


// WEBPACK FOOTER //
// ./src/containers/Admin/Orders/Orders.js